import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04a5df40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-edit-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ID", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ID", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useIsPcView } from "@/hooks/use-is-pc";
import CardWrap from "@/components/common/CardWrap.vue";
import TitleText from "@/components/common/TitleText.vue";
import CompanyCardHeader from "./CompanyCardHeader.vue";
import CompanyCardFooter from "./CompanyCardFooter.vue";
import ListRowWrap from "@/components/common/list/ListRowWrap.vue";
import ListColumn from "@/components/common/list/ListColumn.vue";
import Input from "@/components/common/form/Input.vue";
import Textarea from "@/components/common/form/Textarea.vue";
import Select from "@/components/common/form/Select.vue";
import Loading from "@/components/common/Loading.vue";

import IconContract from "@/assets/svgs/icon_contract.svg";
import IconInvoice from "@/assets/svgs/icon_invoice.svg";
import IconPerson from "@/assets/svgs/icon_person.svg";
import IconCalendar from "@/assets/svgs/icon_calendar.svg";

import companyApi from "@/api/company";
import operatorApi from "@/api/operator";
import paymentMethodApi from "@/api/payment-method";
import invoiceShippingMethodApi from "@/api/invoice-shipping-method";
import { ICompany } from "@/models/company";
import { IOperator } from "@/models/operator";
import { ISelectOption } from "@/models/select-option";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCard',
  setup(__props) {

const isPcView = useIsPcView();
const router = useRouter();
const company = ref<ICompany>({} as ICompany);
const operators = ref<IOperator[]>([]);
const paymentMethods = ref<ISelectOption[]>([]);
const invoiceShippingMethods = ref<ISelectOption[]>([]);
const isLoaded = ref<boolean>(false);

onMounted(async () => {
  await Promise.all([
    companyApi
      .getCompany(router.currentRoute.value.params.id as string)
      .then((res: ICompany) => {
        company.value = res;
      }),
    operatorApi.getOperators().then((res: IOperator[]) => {
      operators.value = res;
    }),
    paymentMethodApi.getPaymentMethods().then((res: ISelectOption[]) => {
      paymentMethods.value = res;
    }),
    invoiceShippingMethodApi
      .getInvoiceShippingMethods()
      .then((res: ISelectOption[]) => {
        invoiceShippingMethods.value = res;
      }),
  ]).then(() => {
    isLoaded.value = true;
  });
});

const operatorsOptions = computed((): ISelectOption[] => {
  return operators.value.map((operator) => {
    return {
      label: operator.name,
      value: operator.id.toString(),
    };
  });
});

const isUpdating = ref<boolean>(false);
const updateAccount = async () => {
  isUpdating.value = true;
  await companyApi
    .updateCompany(company.value)
    .then((res: ICompany) => {
      company.value = res;
    })
    .finally(() => {
      router.go(-1);
      isUpdating.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (!isLoaded.value)
    ? (_openBlock(), _createBlock(Loading, {
        key: 0,
        "is-loading": !isLoaded.value,
        "is-fixed": ""
      }, null, 8, ["is-loading"]))
    : (_openBlock(), _createBlock(CardWrap, { key: 1 }, {
        default: _withCtx(() => [
          (isUpdating.value)
            ? (_openBlock(), _createBlock(Loading, {
                key: 0,
                "is-loading": isUpdating.value,
                "is-fixed": ""
              }, null, 8, ["is-loading"]))
            : _createCommentVNode("", true),
          _createVNode(CompanyCardHeader),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(ListRowWrap, {
              class: "list-row-wrap",
              vertical: !_unref(isPcView)
            }, {
              default: _withCtx(() => [
                _createVNode(ListColumn, { header: "アカウント名" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "company_name",
                      modelValue: company.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((company.value.name) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "請求管理対象" }, {
                  default: _withCtx(() => [
                    _createVNode(Select, {
                      modelValue: company.value.company_setting.invoice_targetted,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company.value.company_setting.invoice_targetted) = $event)),
                      options: [
              { label: '対象', value: 'true' },
              { label: '対象外', value: 'false' },
            ]
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["vertical"]),
            _createVNode(TitleText, {
              text: "契約情報",
              "with-icon": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IconContract), { class: "icon" })
              ]),
              _: 1
            }),
            _createVNode(ListRowWrap, {
              class: "list-row-wrap",
              vertical: !_unref(isPcView)
            }, {
              default: _withCtx(() => [
                _createVNode(ListColumn, { header: "契約プラン" }, {
                  default: _withCtx(() => [
                    _createVNode(Select, {
                      modelValue: company.value.contract_plan,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((company.value.contract_plan) = $event)),
                      options: [
              { label: 'ツールプラン', value: 'simple_plan' },
              { label: 'ベーシックプラン', value: 'basic_plan' },
            ],
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, {
                  header: "年次契約数",
                  style: {"grid-column-start":"1"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "annually_contract_count",
                      modelValue: company.value.company_setting.annually_contract_count,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((company.value.company_setting.annually_contract_count) = $event)),
                      disabled: "",
                      "with-icon": ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "年次契約の期限" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VueDatePicker, {
                      modelValue: company.value.company_setting.annually_contract_expired_date,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((company.value.company_setting.annually_contract_expired_date) = $event)),
                      format: "yyyy/MM/dd",
                      "model-type": "yyyy-MM-dd",
                      "week-start": "0",
                      "enable-time-picker": false,
                      locale: "ja",
                      "auto-apply": "",
                      "text-input": "",
                      disabled: "",
                      clearable: false
                    }, {
                      "input-icon": _withCtx(() => [
                        _createVNode(_unref(IconCalendar), { class: "input-slot-image" })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "年次契約の備考" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "annually_contract_memo",
                      modelValue: company.value.company_setting.annually_contract_memo,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((company.value.company_setting.annually_contract_memo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "月次契約数" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "monthly_contract_count",
                      modelValue: company.value.company_setting.monthly_contract_count,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((company.value.company_setting.monthly_contract_count) = $event)),
                      "with-icon": "",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _createVNode(ListColumn, { header: "月次契約の備考" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "monthly_contract_memo",
                      modelValue: company.value.company_setting.monthly_contract_memo,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((company.value.company_setting.monthly_contract_memo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["vertical"]),
            _createVNode(TitleText, {
              text: "請求情報",
              "with-icon": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IconInvoice), { class: "icon" })
              ]),
              _: 1
            }),
            _createVNode(ListRowWrap, {
              class: "list-row-wrap",
              vertical: !_unref(isPcView)
            }, {
              default: _withCtx(() => [
                _createVNode(ListColumn, { header: "請求先（宛名）" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "invoice_address",
                      modelValue: company.value.company_setting.invoice_address,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((company.value.company_setting.invoice_address) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "請求先（To）" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "invoice_email",
                      modelValue: company.value.company_setting.invoice_email,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((company.value.company_setting.invoice_email) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "請求書送付方法" }, {
                  default: _withCtx(() => [
                    _createVNode(Select, {
                      modelValue: company.value.company_setting.invoice_shipping_method,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((company.value.company_setting.invoice_shipping_method) = $event)),
                      options: invoiceShippingMethods.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "請求期日" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "invoice_due_date",
                      modelValue: company.value.company_setting.invoice_due_date,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((company.value.company_setting.invoice_due_date) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "振込期日" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "transfer_due_date",
                      modelValue: company.value.company_setting.transfer_due_date,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((company.value.company_setting.transfer_due_date) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "支払い方法" }, {
                  default: _withCtx(() => [
                    _createVNode(Select, {
                      modelValue: company.value.company_setting.payment_method,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((company.value.company_setting.payment_method) = $event)),
                      options: paymentMethods.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "freee取引ID" }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      id: "freee_account_id",
                      modelValue: company.value.company_setting.freee_account_id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((company.value.company_setting.freee_account_id) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["vertical"]),
            _createVNode(ListRowWrap, {
              class: "list-row-wrap list-row-mt-n",
              vertical: true
            }, {
              default: _withCtx(() => [
                _createVNode(ListColumn, { header: "社内メモ" }, {
                  default: _withCtx(() => [
                    _createVNode(Textarea, {
                      id: "memo",
                      modelValue: company.value.company_setting.memo,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((company.value.company_setting.memo) = $event)),
                      placeholder: "社内メモ",
                      rows: "5"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TitleText, {
              text: "Co-Growth社内担当者",
              "with-icon": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IconPerson), { class: "icon" })
              ]),
              _: 1
            }),
            _createVNode(ListRowWrap, {
              class: "list-row-wrap",
              vertical: !_unref(isPcView)
            }, {
              default: _withCtx(() => [
                _createVNode(ListColumn, { header: "経理担当" }, {
                  default: _withCtx(() => [
                    _createVNode(Select, {
                      modelValue: company.value.company_setting.accounting_operator_id,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((company.value.company_setting.accounting_operator_id) = $event)),
                      options: operatorsOptions.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(ListColumn, { header: "取引担当" }, {
                  default: _withCtx(() => [
                    _createVNode(Select, {
                      modelValue: company.value.company_setting.cs_operator_id,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((company.value.company_setting.cs_operator_id) = $event)),
                      options: operatorsOptions.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["vertical"])
          ]),
          _createVNode(CompanyCardFooter, { "update-account": updateAccount })
        ]),
        _: 1
      }))
}
}

})